import * as React from "react";
import RaspaKPIs from "./RaspaKPIs";
import { format, parseISO } from 'date-fns'
import NotasPag1 from "./NotasPag1";
import DistribuicaoNoTempo from "./DistribuicaoNoTempo";
import {makeStyles} from "@material-ui/styles";
import mock from "../mock.json";
import mockFilter from "../mockFilter.json";
import PaginaA4 from "../../../../components/reports/paginaA4";

const useStyles = makeStyles(theme => ({



}));


const Pagina1 = (props) => {
    const classes = useStyles();

    const raspaReportData = props.raspaReportData? props.raspaReportData : mock;
    const filter = props.filter? props.filter : mockFilter;


    return (
        <PaginaA4
            titulo={'PRODUTIVIDADE RASPAROBO LUKATEC'}
            subtitulo={`PERIODO ${format(parseISO(raspaReportData.periodo.periodo.periodoIni),'dd/MM/yyyy')} A ${format(parseISO(raspaReportData.periodo.periodo.periodoFim),'dd/MM/yyyy')}`}
            areaCima={<React.Fragment>
                            <RaspaKPIs
                                       raspaReportData={raspaReportData}
                                       filter={filter} />
                            <DistribuicaoNoTempo
                                                 raspaReportData={raspaReportData}
                                                 filter={filter} />
                      </React.Fragment>}
            areaBaixo={<NotasPag1/>}
            // rodape={`PERIODO COMPARATIVO: ${format(parseISO(raspaReportData.periodoComparacao.periodo.periodoIni),'dd/MM/yyyy')} A ${format(parseISO(raspaReportData.periodoComparacao.periodo.periodoFim),'dd/MM/yyyy')}`}
            pagina={1}
        />
    )
}


export default  Pagina1;